import { http, getBaseUrl } from '@cap/rzmt-core';
import { appEnv } from '@cap/share/src/bootstrap';

/**
 * 查询页面模块配置
 */
export const getModuleTemplate = <T>() => {
  return http.post<T>('tdxxueyuanhomepageservice_querymoduletemplate', {
    // 新首页pageType固定为 4
    pageType: 4,
  });
};

/**
 * 获取分类数据
 */
export const getClassifyList = <T>() => {
  return http.post<T>('tdxcourseclassifyservice_querydimensionclassify');
};

export const getBannerList = <T>(params: { moduleId: number }) => {
  const { moduleId } = params;
  const data = {
    pageNo: 1,
    pageSize: 5,
    clientType: 1,
    moduleId,
  };
  return http.post<T>('tdxbannerservice_page', data);
};

/**
 * 获取首页信息
 */
export const getHomePage = (data: { clientType: number[] }) => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxxueyuanhomepageservice_gethomepage',
    method: 'post',
    data: {
      pageId: 4,
      ...data,
    },
  });
};

/**
 * 获取首页信息
 */
export const getPreviewHomePage = (data: { key: string }) => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxxueyuanhomepageservice_gethomepagepreviewbykey',
    method: 'post',
    data: {
      ...data,
    },
  });
};

export interface IModuleCourseData {
  pageNo?: number;
  pageSize?: number;
  moduleIdList: number[];
  dataRule: string;
}

/**
 * 查询首页模块关联课程列表
 */
export const getModuleCourse = (data: IModuleCourseData) => {
  const baseURL = getBaseUrl(appEnv);
  return http({
    baseURL,
    url: 'tdxcoursebannerservice_querymodulecourse',
    method: 'post',
    data: {
      // 要查询的学院Id,培训默认值0
      pageNo: 1,
      pageSize: 10,
      tenantId: 0,
      ...data,
    },
  });
};

/**
 * 关键字查询课程 tdxsearchservice_multisearch
 */

export const getKeyModuleCourse = (data: IModuleCourseData) => {
  const baseURL = getBaseUrl(appEnv);
  return http({
    baseURL,
    url: 'tdxsearchservice_multisearch',
    method: 'post',
    data: {
      // 要查询的学院Id,培训默认值0
      pageNo: 1,
      pageSize: 12,
      ...data,
    },
  });
};

/**
 * 预约/取消预约直播课
 */

export interface ScheduleLive {
  id: number;
  shortUrl: number;
  tenantId: string;
  isSetRemind: boolean;
}

export const scheduleLiveBroadcast = (data: ScheduleLive) => {
  const baseURL = getBaseUrl(appEnv);
  const url = data.isSetRemind
    ? `tdxuserservice_deleteremind?tenant=${data.shortUrl}`
    : `tdxuserservice_addremind?tenant=${data.shortUrl}`;
  return http({
    baseURL,
    url,
    method: 'post',
    data: {
      courseId: data.id,
      tenantId: data.tenantId,
    },
  });
};

/**
 * 查询学习时长信息
 */
export const learningDuration = () => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxlearnrecordstaticservice_duration',
    method: 'post',
    data: {},
  });
};

/**
 * 查询最近在学
 */
export const studyingRecently = (data = {}) => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxlearnrecordservice_getrecentlearn',
    method: 'post',
    data: {
      pageSize: 3,
      pageNo: 1,
      ...data,
    },
  });
};

/**  查询报名课程 registerCourses
 * tdxlearnrecordservice_getregistrationlearn
 */

export const registerCourses = (data = {}) => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxlearnrecordservice_getregistrationlearn',
    method: 'post',
    data: {
      pageSize: 3,
      pageNo: 1,
      ...data,
    },
  });
};

/**  查询直播课预约状态
 *
 */
export const checkAppointment = (courseIds) => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxuserservice_queryreminddatebyids',
    method: 'post',
    data: { courseIds },
  });
};

/**  预览
 *
 */

export const homePreview = (key) => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxxueyuanhomepageservice_gethomepagepreviewbykey',
    method: 'post',
    data: { key },
  });
};

export const getUserProfile = (params) => {
  const baseURL = getBaseUrl(appEnv);

  return http({
    baseURL,
    url: 'tdxuserservice_profile',
    method: 'post',
    data: { ...params },
  });
};
